import { Component } from '@angular/core';
import {
  OnInit,
  OnDestroy,
  ElementRef,
  ViewChild
} from '@angular/core';

import ArcGISMap from '@arcgis/core/Map';
import Graphic from '@arcgis/core/Graphic';
import MapView from '@arcgis/core/views/MapView';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import Collection from "@arcgis/core/core/Collection";
import CustomContent from '@arcgis/core/popup/content/CustomContent';
import PopupTemplate from '@arcgis/core/PopupTemplate';
import SimpleRenderer from "@arcgis/core/renderers/SimpleRenderer";
import TextSymbol from "@arcgis/core/symbols/TextSymbol";
import { MapService } from 'src/app/service/map-page.service';
import { FormControl } from '@angular/forms';
import * as ArcMap from '@arcgis/core/Map';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription, filter, fromEvent, lastValueFrom, map, pairwise } from 'rxjs';
import Extent from '@arcgis/core/geometry/Extent';
import PictureMarkerSymbol from '@arcgis/core/symbols/PictureMarkerSymbol';
import Point from '@arcgis/core/geometry/Point';
import { MessageService } from 'primeng/api';
import Basemap from '@arcgis/core/Basemap';
import { Location } from '@angular/common';
import { FastAPIService, News } from 'src/app/service/fast-api.service';
import UniqueValueRenderer from '@arcgis/core/renderers/UniqueValueRenderer';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent implements OnInit, OnDestroy{
  constructor(private route: ActivatedRoute, private router: Router, private fastService: FastAPIService, private location: Location, private mapService: MapService, private messageService: MessageService) {}

  @ViewChild('mapViewNode', { static: true }) private mapViewEl!: ElementRef;
  public view: any = null;
  currentNews_link: string = "";
  currentNews: News = new News();
  newsSuggestions: News[] = [];
  data: any[] = [];

  initializeMap(): Promise<any> {
    const container = this.mapViewEl.nativeElement;

    const basemap = new Basemap({
      portalItem: {
        id: 'bc19c34549de4000bcd91cef929420dc'
      }
    });

    const map = new ArcMap.default({
      basemap: basemap
    });

    const view = new MapView({
      container: container,
      map: map,
      zoom: 5,
      center: [100.523186, 13.736717],
      constraints: {
        minZoom: 2,
        geometry: new Extent({
          xmin: -180,
          ymin: -80,
          xmax: 180,
          ymax: 75
        })
      }
    })

    const popupTemplate = new PopupTemplate({
      title: "{Topic_OD}",
      content: [
        new CustomContent({
          outFields: ["*"],
          creator: (event: any) => {
            const img = document.createElement("img");
            img.src = event.graphic.attributes.Picture_URL_OD;
            return img;
          }
        })
      ],
      outFields: ["*"]
    });
    for(let news of this.newsSuggestions) {
      this.data.push({
        lat: news.LAT_LON_List[0],
        lon: news.LAT_LON_List[1],
        views: news.Views,
        picture: news.Picture_URL_OD[0],
        title: news.Topic_OD,
        link: news.Link_OD,
        link_icon: news.icon
      })
    }

    const layer = new FeatureLayer({
      source: new Collection(this.newsSuggestions.map((d, i) => (
        {
          geometry: {
            type: "point",
            longitude: Number(String(d.LAT_LON_List[0]).split(',')[1]),
            latitude: Number(String(d.LAT_LON_List[0]).split(',')[0])
          },
          attributes: {
            ObjectID: i,
            ...d
          }
        }
      ))),
      fields: [
        {
          name: "ObjectID",
          alias: "ObjectID",
          type: "oid"
        },
        {
          name: "Topic_OD",
          alias: "Topic",
          type: "string"
        },
        {
          name: "LAT_LON_List",
          type: "string"
        },
        {
          name: "longitude",
          type: "string"
        },
        {
          name: "Detail_OD",
          alias: "Detail",
          type: "string"
        },
        {
          name: "Link_OD",
          alias: "Link",
          type: "string"
        },
        {
          name: "Picture_URL_OD",
          alias: "Picture",
          type: "string"
        },
        {
          name: "isMainNews",
          alias: "isMainNews",
          type: "string"
        }
      ],  
      objectIdField: "ObjectID",
      geometryType: "point",
      renderer: new UniqueValueRenderer({
        field: "isMainNews",
        defaultSymbol: new PictureMarkerSymbol({
          url: 'assets/map-page-component-images/subPin.svg',
          width: '22px',
          height: '30px'
        })
      }),
      popupTemplate
    });
    // console.log(layer)
    map.add(layer);
    this.view = view;
    return this.view.when();
  }

  async ngOnInit(): Promise<any> {
    this.currentNews_link = 'https:%2F%2Fwww.bbc.com%2Fthai%2Farticles%2Fc6pxkz8ldm8o'
    this.currentNews = await this.fastService.searchWithLink(this.currentNews_link);
    // console.log(this.currentNews)
    this.newsSuggestions =  (await this.fastService.getSearchResult(this.currentNews.Topic_OD, 0, 10, "example")).newsList.filter(news => {return news.LAT_LON_List});
    // console.log(this.newsSuggestions);

    

    this.initializeMap().then(() => {
      // console.log('The map is ready.');
    });
  }

  ngOnDestroy(): void {
    if (this.view) {
      this.view.destroy();
    }
  }
}
